import styled from "styled-components";

import { BankStatus } from "../../../types/common";

type BankStatusBoxProps = {
    status: BankStatus | undefined;
};

const BankStatusBox = ({ status }: BankStatusBoxProps): JSX.Element => {
    const content = () => {
        switch (status) {
            case BankStatus.ACTIVE:
                return <StyledActivated>Active</StyledActivated>;
            case BankStatus.INACTIVE:
                return <StyledDeactivated>Inactive</StyledDeactivated>;
            case BankStatus.PENDING_APPROVAL:
                return <StyledPending>Pending Approval</StyledPending>;
            case BankStatus.PENDING_EDIT_APPROVAL:
                return <StyledPending>Pending Edit Approval</StyledPending>;
            case BankStatus.DRAFT:
                return <StyledPending>Draft</StyledPending>;
            default:
                return <></>;
        }
    };

    return content();
};

export const BankStatusText = (status : BankStatus): string => {
    switch (status) {
        case BankStatus.ACTIVE:
            return "Active";
        case BankStatus.INACTIVE:
            return "Inactive";
        case BankStatus.PENDING_APPROVAL:
            return "Pending Approval";
        case BankStatus.PENDING_EDIT_APPROVAL:
            return "Pending Edit Approval";
        case BankStatus.DRAFT:
            return "Draft";
        default:
            return "";
    }
};

const StyledDiv = styled.div`
    display: inline-block;
    padding: 3px 6px;
    border-radius: 0px;
    font-size: 12px;
`;

const StyledActivated = styled(StyledDiv)`
    background: #00847F;
    color: #ffffff;
`;
const StyledDeactivated = styled(StyledDiv)`
    background: #A8000B;
    color: #ffffff;
`;
const StyledPending = styled(StyledDiv)`
    background: #D7D8D6;
    color: #333333;
`;

export default BankStatusBox;
